import styled from 'styled-components'

import { mq, sizes } from '../../../theme'

export const Container = styled.div`
  display: block;
  padding: 2rem;
  width: 100%;
  margin: 0 auto;
`

const CommonsSliderStyles = styled.div<{
  currentValue: number
  isForQuizz?: boolean
}>`
  .rc-slider {
    display: block;
  }

  .rc-slider-dot {
    border: none;
    background: ${({ theme }) => theme.colors.grey61};
    width: 0.4rem;
    height: 0.4rem;
  }

  .rc-slider-dot-active {
    border: none;
    background: ${({ theme }) => theme.colors.pureBlack};
  }

  .rc-slider-handle {
    background-color: ${({ theme, isForQuizz }) =>
      isForQuizz ? theme.colors.pureBlack : theme.colors.greenApple};
    width: 2rem;
    height: 2rem;
    border: none;
  }

  .rc-slider-rail {
    background-color: ${({ theme }) => theme.colors.alto};
  }

  .rc-slider-track {
    background-color: transparent;
  }

  .rc-slider-mark {
    width: 100%;
  }

  .rc-slider-mark-text {
    ${({ theme }) => theme.textStyles.text_bold_condensed_14};
    color: ${({ theme }) => theme.colors.grey8b};

    @media ${mq(sizes.desktop)} {
      ${({ theme }) => theme.textStyles.text_bold_condensed_16};
    }
  }

  .rc-slider-mark-text-active:nth-child(${({ currentValue }) =>
        `${currentValue + 1}`}) {
    color: ${({ theme }) => theme.colors.pureBlack};
    font-size: ${({ isForQuizz }) => (isForQuizz ? '2.6rem' : '1.4rem')};
    transform: ${({ isForQuizz }) =>
      isForQuizz ? 'translate(-100%, -200%) !important' : ''};
    @media ${mq(sizes.desktop)} {
      font-size: ${({ isForQuizz }) => (isForQuizz ? '2.6rem' : '1.4rem')};
      transform: ${({ isForQuizz }) =>
        isForQuizz ? 'translate(-50%, -275%) !important' : ''};
    }
  }
`

export const DesktopSlider = styled(CommonsSliderStyles)`
  display: none;

  @media ${mq(sizes.desktop)} {
    display: block;
  }

  .rc-slider-dot {
    transform: translateY(-0.2em);
  }

  .rc-slider-handle {
    margin-top: -0.8rem;
  }

  .rc-slider-mark-text {
    overflow: hidden;
    white-space: nowrap;
    margin-top: 1rem;
    transform: ${({ isForQuizz }) =>
      isForQuizz ? 'translate(-50%, -350%) !important' : ''};
  }
`

export const MobileSlider = styled(CommonsSliderStyles)<{
  itemsNumber: number
  isForQuizz?: boolean
}>`
  height: ${({ itemsNumber, isForQuizz }) =>
    isForQuizz ? 'inherit' : `${itemsNumber * 3.5}rem`};
  display: block;

  @media ${mq(sizes.desktop)} {
    display: none;
  }

  .rc-slider-dot {
    transform: translateX(0.2rem);
    bottom: ${({ isForQuizz }) => (isForQuizz ? '0 !important' : '2px')};
  }

  .rc-slider-vertical {
    margin: 0 auto;
    min-width: 20rem;
  }

  .rc-slider-handle {
    margin-top: -0.6rem;
    margin-left: ${({ isForQuizz }) =>
      isForQuizz ? '-0.7rem !important' : '-0.8rem !important'};
  }

  .rc-slider-mark-text {
    margin-left: ${({ isForQuizz }) => (isForQuizz ? '0' : '2rem')};
    margin-top: -0.5rem;
    transform: ${({ isForQuizz }) =>
      isForQuizz ? 'translate(-50%, -250%) !important' : ''};
  }
`
